import React, { useEffect, useState } from 'react';
import { TextField } from '@material-ui/core';

/**
 * @param {string} stringValue
 * @returns {number}
 */
const parseTimeString = (stringValue) => {
    stringValue = stringValue.replace(/[^\d:]/g, '');
    const split = stringValue.includes(':') ? stringValue.split(':') : `${stringValue}:`.split(':');
    const hours = Number(split[0].substring(0, 2));
    const parsedMinutes = Number(split[1].substring(0, 2));
    const roundedMinutes = Math.ceil(parsedMinutes / 15) * 15;
    const minutes = roundedMinutes >= 60 ? 0 : roundedMinutes;
    return hours + minutes / 60.0;
};

/**
 * @param {number} num
 */
const setTwoDigits = (num) => `0${Math.floor(num)}`.slice(-2);

/**
 * @param {number} value
 * @returns {string}
 */
const getTimeString = (value) => {
    const hours = setTwoDigits(value);
    const minutes = setTwoDigits((value * 60) % 60);
    return `${hours}:${minutes}`;
};

const DurationInput = ({ onChange, value, ...others }) => {
    const [displayedValue, setDisplayedValue] = useState(others.placeholder && (value === null || value === 0) ? "" : getTimeString(value));
    const changeOnBlur = (ev, updatedValue) => {
        const parsedValue = parseTimeString(ev.target.value);
        onChange(parsedValue, updatedValue);
        setDisplayedValue(getTimeString(parsedValue));
    };

    useEffect(() => {
        setDisplayedValue(others.placeholder && (value === null || value === 0) ? "" : getTimeString(value));
    }, [value]);

    return (
        <TextField
            size={others.size ?? "medium"}
            onChange={(ev) => setDisplayedValue(ev.target.value)}
            onBlur={changeOnBlur}
            value={displayedValue}
            {...others}
        />
    );
};

export default DurationInput;
